
// src/i18n/message-en.js

import moment from 'moment'

export default {
  initialize: ()=> {
    moment.locale('en')
    moment.updateLocale('en', {
      longDateFormat: {
        LLLL: "MMM Do YYYY, ddd",
        llll: "MMM Do, ddd",
        ll: "MMM, YYYY",
        l: "HH:mm"
      },
    })
  },
  message: {
    "ようこそ": "Welcome to gamba!", // gamba! にようこそ！
    "ログインしてください": "Please login.", // ログインしてください。
    "メンテナンス中": "Under maintenance now. \n\ngamba! is working day and night to improve its features. \n\nYou will be able to use gamba! \nPlease wait for a while. \nPlease see the following for the notification of maintenance from our company.",
  },
  diary: {
    memo: "Note", // 'ノート',
    diary: "Daily", // '日報',
    kpi: "KPI", // 'KPI',
    "diaryを書く": "Post new daily", // 今日はどんな仕事をしましたか? ここをクリックして入力しましょう。
    "kpiを書く": "Post KPI report", // 今日のKPIは順調でしたか? ここをクリックして入力しましょう。
    "memoを書く": "Post new note", // どんな内容でしたか? ここをクリックして入力しましょう。
    "diaryを投稿" : "I posted a daily report. good job for today!", //日報を投稿しました。お疲れ様でした！
    "kpiを投稿" : "I posted a KPI. good job for today!", //KPIを投稿しました。お疲れ様でした！
    "memoを投稿" : "I posted a note", //ノートを投稿しました。
  },
  format: {
    diary_subject: "{{category}} on {{reported_at, date}}", // {{ reported_at, date}}の {{category}}
    timestamp: "{{timestamp, fromNow}}", // {{ timestamp, fromNow }}
    savedAt: "Save to {{timestamp, fromNow}}", // {{ timestamp, fromNow }}に保存
    month: "MMM, YYYY",
  },
  calendar: {
    monthNames: 'January_February_March_April_May_June_July_August_September_October_November_December',
    monthNamesShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec',
    dayNames: 'Sun_Mon_Tue_Web_Thu_Fri_Sat',
    dayNamesShort: 'Sun_Mon_Tue_Web_Thu_Fri_Sat',
  },
  label: {
    "gamba": "Daily report application gamba!", // 日報アプリgamba!
    "株式会社gamba": "gamba, Inc.", // 株式会社gamba
    "無料": "Free", // 無料
    "ピックアップ": "Pick up", // ピックアップ
    "アプリ名": "gamba!", // gamba!
    "お問い合わせ": "Click here for other inquiries", // その他お問い合わせはこちら
    "ヘルプページを開く": "Open help page", // ヘルプページを開く
    "入門ガイドを開く": "Open Getting Started Guide", // 入門ガイドを開く
    "問い合わせる": "Contact support", // サポートに問い合わせ
    "アプリもあります": "Convenient smartphone app now! From here", // 便利なスマートフォンアプリはいますぐ！こちらから
    "お知らせがあります": "I have news", // お知らせがあります
    "更新が必要です": "Update required", // 更新が必要です
    "更新する": "Update", // 更新する
    "gambaで開く": "Open with gamba!", // gamba!で開く
    "サービスが更新されています": "The service has been updated. Reload now.", // サービスが更新されています。いますぐ、再読み込みを行なってください。
    "お知らせを開く": "Open announcement", // お知らせを開く
    "新着のお知らせ": "News of the latest arrival of gamba!", // gamba!の新着のお知らせ
    "新着のメッセージ": "Message from {{name}}", //  {{name}} さんからのメッセージ
    "添付ファイルが届いています": "The attached file has arrived.", // 添付ファイルが届いています。
    "メールアドレスを確認してください": "Please confirm your email address", // メールアドレスを確認ください
    "メールアドレスの確認が完了していません": "Email address verification not completed", // メールアドレスの確認が完了していません
    "メールアドレスの確認を行ってください": "Confirmation mail has been sent to your email address. Open this email and complete your email address verification. If you do not see the email, please resend it below.", // お客様のメールアドレス宛に「gamba! 登録のお知らせ」メールを送信しております。こちらのメールを開き、メールアドレスの確認を完了してください。もしメールが見当たらない場合は、以下より再送を行なってください。
    "確認メール再送": "Confirmation email resend", // 確認メール再送
    "サービスは現在ご利用いただけません": "Service is currently unavailable.", // サービスは現在ご利用いただけません。
    "お知らせページを開く": "Open notification page", // お知らせページを開く
    "メニュー": "Menu", // メニュー
    "検索結果": "Search results", // 検索結果
    "新着の通知": "New notifications", // 新着の通知
    "カレンダー": "Calendar",
    "カレンダー連携": "Connect to Calendar",
    "カレンダーを解除": "Cancel Calendar",
    "Googleカレンダー": "Google Calendar", // Googleカレンダー
    "Googleカレンダーに接続": "Connect to Google Calendar", // Googleカレンダーに接続
    "Googleドライブに接続する": "Connect to GoogleDrive", // Googleドライブに接続する
    "Googleカレンダーを解除": "Cancel Google Calendar", // Googleカレンダーを解除
    "Googleドライブに連携する": "Link To GoogleDrive", // Googleドライブに連携する
    "Googleドライブを解除": "Cancel GoogleDrive", // Googleドライブを解除
    "日報のエクスポートは最大1年分": "Daily reports can be exported for up to 1 year. Please perform the operation again.", // 日報のエクスポートは最大1年分をエクスポート可能です。再度、操作を行なってください。
    "Outlookカレンダー": "Outlook Calendar (Beta版)",  // Outlookカレンダー (Beta版)
    "Outlookカレンダーに接続": "Connect to Outlook Calendar (Beta版))",  // Outlookカレンダーに接続 (Beta版)
    "Outlookカレンダーを解除": "Cancel Outlook Calendar" ,  // Outlookカレンダーを解除
    "説明を表示": "show explanation", // 説明を表示
    "時間を表示": "show time", // 時間を表示
    "貼付ヒント": "If you check it and press \"Paste\", the \"explanation\" of the schedule will be added.", //チェックを入れて「貼付け」を押すとその日程の「説明」が追加されます。
    "カレンダーの予定を貼り付けました": "Pasted calendar event", // カレンダーの予定を貼り付けました
    "予定がありません": "There is no plan.", // 予定がありません。
    "メンバーリスト" : "Member list", //メンバーリスト
    "メンバーとミッション": "Members and missions", // メンバーとミッション
    "ミッションが設定されていません": "Mission not set.", // ミッションが設定されていません。
    "グループのメンバー": "{{name}} members", //  {{name}} のメンバー
    "メンバー": "member", // メンバー
    "メンバーを追加" : "Add member", //メンバーを追加
    "設定" : "setting", // 設定
    "日報提出状況": "Submission status", // 日報提出状況
    "インサイト": "Insights", // インサイト
    "アルバム" : "album" , //アルバム
    "データがありません" : "No Data",
    "詳細をすべて表示": "View all details", // 詳細をすべて表示
    "KPI進捗状況": "KPI progress", // KPI進捗状況
    "KPIの進捗状況": "{{name}} progress", //  {{name}} の進捗状況
    "添付ファイル": "Attachments", // 添付ファイル
    "画像" : "image", // 画像
    "動画・音声" : "video・audio", // 動画
    "ファイル" : "file", // ファイル
    "アルバム" : "album", //アルバム
    "ログイン": "Login", // ログイン
    "確認コード": "Confirmation code", // 確認コード
    "確認コードについて": "6-digit confirmation code has sent to your email to verify your identity. Please check it.", // 本人確認のため、数字6桁の確認コードをメールで送信しましたので、確認してください。
    "次へ": "Next", // 次へ
    "いますぐログイン": "Login now!", // いますぐログイン！
    "うまくログインできない時": "Can't log in? Have a look at this", // ログインできない？こちらをご覧ください
    "無料体験に登録": "Is this your first time to use this app? Register for free trial here", // 無料体験への登録はこちら
    "無料体験の登録方法": "Click here to register for a free trial", // 無料体験への登録方法はこちら
    "このアプリについて": "About this app", // このアプリについて
    "アプリの説明": "Developed and operated daily report sharing application gamba!\nVersion: {{version}} ({{label}})\nOS: {{OS}}\nDevice: {{device}}\nModel: {{model}}", // "日報共有アプリ gamba!\n開発・運営
    "アプリの説明 モデル無し": "Developed and operated daily report sharing application gamba!\nVersion: {{version}} ({{label}})\nOS: {{OS}}\nDevice: {{device}}", // "日報共有アプリ gamba!\n開発・運営
    "アプリの説明(staging)": "Developed and operated daily report sharing application gamba!\nVersion: {{version}} ({{label}})\nOS: {{OS}}\nDevice: {{device}}\nModel: {{model}}\nStaging", // "日報共有アプリ gamba!\n開発・運営
    "アプリの説明 モデル無し(staging)": "Developed and operated daily report sharing application gamba!\nVersion: {{version}} ({{label}})\nOS: {{OS}}\nDevice: {{device}}\nStaging", // "日報共有アプリ gamba!\n開発・運営
    "メールアドレスを選択": "Select email address", // メールアドレスを選択
    "パスワードの変更が必要です": "You need to change your password.", // パスワードの変更が必要です。
    "パスワードを変更してログイン": "Change password and login", // パスワードを変更してログイン
    "シングルサインオン認証を行ってください": "Authenticate through Single Sign On.", // シングルサインオン認証を行ってください。
    "メールアドレス": "Mail address", // メールアドレス
    "パスワード": "Password", // パスワード
    "個人設定": "User settings", // 個人設定
    "グループ設定": "Group settings", // グループ設定
    "グループ新規作成": "Create new group", // グループ新規作成
    "プロフィール設定": "Profile settings", // プロフィール設定
    "お気に入り登録": "Follow settings", // フォロー設定
    "フォロー": "Follow", // フォロー
    "フォロー中": "Following", // フォロー中
    "お気に入りに追加": "To follow", // フォローする
    "お気に入りから削除": "Unfollow", // フォローを外す
    "ブロック": "block",  // ブロック
    "ブロックリスト": "Block list", // ブロックリスト
    "ブロック解除": "blocked",  // ブロックしています
    "ユーザのブロック": "Block this user.", // このユーザをブロックをします。
    "ブロックユーザの解除": "Remove {{ name }} from this list.",  // {{ name }}のブロックを解除します。
    "ユーザのブロック説明": "If you block, you will not see this user's posts in your All Posts or group timeline. You can unblock from the blocked user timeline or from \"Preferences\" > \"Block List\".",  // ブロックした場合、あなたの「すべての投稿」やグループのタイムラインからこのユーザの投稿が表示されなくなります。ブロック解除はブロックしたユーザのタイムラインか 「個人設定」 > 「ブロックリスト」から解除できます。
    "ブロックユーザの解除説明": "Once unblocked, you'll see this user's posts in your All Posts and group timelines.",  // ブロック解除した場合、あなたの「すべての投稿」やグループのタイムラインにこのユーザの投稿が表示されるようになります。
    "投稿のブロック": "Block this post.",    // この投稿をブロックします。
    "投稿のブロック解除": "Unblock this post.",  // この投稿のブロックを解除します。
    "投稿のブロック説明": "If blocked, this post will not appear in your All Posts or group timeline. Unblocking can be done from the blocked user's timeline.",  // ブロックした場合、あなたの全ての投稿やグループのタイムラインから表示されなくなります。
    "投稿のブロック解除説明": "If unblocked, this post will be visible from all posts and group timelines.",  // ブロック解除した場合、この投稿が全ての投稿やグループのタイムラインから表示されるようになります。
    "投稿ブロックされています": "This post has been blocked.",  // この投稿はブロックされています。
    "ユーザブロックされています": "This user has been blocked.",  // このユーザはブロックされています。
    "パスワード変更": "Change Password", // パスワード変更
    "パスワード再発行": "Don't know password? Click here for reissue", // パスワードがわからない? 再発行はこちら
    "gambaについて": "Want to know more about gamba!", // gamba!について知りたい? 詳しくはこちら
    "通知設定": "Notification settings", // 通知設定
    "自分用テンプレート": "My template", // 自分用テンプレート
    "共通テンプレート": "Common template", // 共通テンプレート
    "アカウント管理": "Account management", // アカウント管理
    "アカウント管理画面を開く": "Open account management screen", // アカウント管理画面を開く
    "ログアウト": "Logout", // ログアウト
    "ログアウトします": "Log out", // ログアウトします
    "基本設定": "Basic setting", // 基本設定
    "メンバー管理": "Member management", // メンバー管理
    "KPI設定": "KPI settings", // KPI設定
    "ごみ箱に移動": "Move to trash", // ごみ箱に移動
    "ダウンロード": "Download", // ダウンロード
    "チャット": "Chat", // チャット
    "チャットをする": "Start Chat",
    "ご自身のユーザーでチャットを行うことはできません": "You cannot chat with your own users",
    "対象ユーザーはこのチャットルームには参加していません。" : "Target users are not participating in this chat room", //対象ユーザーはこのチャットルームには参加していません
    "日報提出状況": "Daily report submission status", // 日報提出状況
    "未読の投稿": "Unread posts", // 未読の投稿
    "未読の投稿があります": "There are {{unreadCount}} unread posts.", // {{ unreadCount }}件の未読の投稿があります。
    "未読の投稿がたくさんあります": "There are more than 10 unread posts.", // 10件以上の未読の投稿があります。
    "件": "Cases", // 件
    "件以上": "More than", // 件以上
    "すべて開封にする": "All opened", // すべて開封
    "未読の投稿を開く": "Open unread posts", // 未読の投稿を開く
    "目標": "Goal", // 目標
    "実績": "Performance", // 実績
    "合計実績": "Total performance", // 合計実績
    "累計": "Cumulative", // 累計
    "達成率": "Achievement rate", // 達成率
    "合計達成率": "Total achievement rate", // 合計達成率
    "達成ライン": "100% Achievement line", // 100%達成ライン
    "合計": "Total", // 合計
    "達成": "Achieved!", // 達成 !
    "返信": "Reply", // 返信
    "内容": "Content", // 内容
    "添付": "Attachment", // 添付
    "了解": "OK", // 了解
    "完了": "Done", // 完了
    "送信": "Submit", // 送信
    "登録": "Register", // 登録
    "更新": "Update", // 更新
    "提出": "Submission", // 提出
    "新規作成": "Create New", // 新規作成
    "編集": "Edit", // 編集
    "概要": "Overview", // 概要
    "詳細": "Details", // 詳細
    "戻る": "Return", // 戻る
    "操作": "Operation", // 操作
    "gambaアプリで開く": "Open this page with gamba!", // このページをgamba!アプリで開く
    "アプリで開く": "Open with app", // アプリで開く
    "アプリをダウンロード": "Download app", // アプリをダウンロード
    "アプリを使用しない": "Do not use gamba! app", // gamba!アプリを使用しない
    "クリックして値を更新": "Click to update value", // クリックして値を更新
    "アイコン画像": "Icon image", // アイコン画像
    "自分のミッション": "Your mission", // 自分のミッション
    "グループのミッション": "Group Mission", // グループのミッション
    "写真動画を選択": "Select Image / Movie", // 写真・動画を選択
    "ドキュメントを選択":"Select documents",  // ドキュメントを選択
    "ファイルを選択":"Select files",  // ファイルを選択
    "エクスポート": "Export", // エクスポート
    "送信方法": "Sending Method", // 送信方法
    "フォルダの選択":"Select Folder",  // フォルダの選択
    "保存先":"Save Location",  // 保存先
    "メールに送信":"Send to Email",  // メールに送信
    "ローカルに保存":"Save Local",  // ローカルに保存
    "Refresh Token":"Refresh Token", // Refresh Token
    "Refresh Tokenの取得":"Get Refresh Token", // Refresh Tokenの取得
    "Googleドライブが設定されていません":"GoogleDrive is not set up", // Googleドライブが設定されていません
    "連携済み":"Already linked", // 連携済み
    "定期的にGoogleドライブへ自動保存する":"Save to GoogleDrive Automatically", // 定期的にGoogleドライブへ自動保存する
    "定期実行設定":"Scheduled Execution Settings", // 定期実行設定
    "定期実行":"Scheduled Execution", // 定期実行
    "有効にする":"Activate", // 有効にする
    "フォルダを選択して下さい1": "Select a folder", // フォルダを選択して下さい
    "フォルダを選択して下さい": "---Select a folder---", // フォルダを選択して下さい
    "期間設定": "Period Settings", // 期間設定
    "日付": "Date", // 日付
    "間隔": "Interval", // 間隔
    "週": "Week", // 週
    "月次": "Month", // 月
    "ユーザ": "A user", // ユーザ
    "ユーザ名": "User name", // ユーザ名
    "社員番号": "Employee number", // 社員番号
    "部署": "Department", // 部署
    "誕生日": "Birthday", // 誕生日
    "部署を選択": "Select department", // 部署を選択
    "誕生日を追加": "Add birthday", // 誕生日を追加
    "部署が設定されていません": "Department is not set. Contact your accountadministrator.", // 部署が設定されていません
    "グループ名": "Group name", // グループ名
    "セクション/グループ名を検索": "Search groups", // グループ名を検索
    "並べ替え": "Sort", // グループ名を並べ替え
    "現在のパスワード": "Current password", // 現在のパスワード
    "新しいパスワード": "New password", // 新しいパスワード
    "新しいパスワード(再入力)": "New password (re-enter)", // 新しいパスワード(再入力)
    "ミッションを入力してください": "Please enter a mission.", // ミッションを入力してください。
    "メールアドレスを更新しました": "For confirmation, we sent an e-mail to gamba! Please confirm your e-mail address to your new e-mail address.", // 確認のため、新しいメールアドレス宛に「gamba!よりメールアドレス確認のお願い」というメールを送信しましたので、ご確認ください。
    "メールアドレス確認待ち": "Changing email address to {{email}}.", // メールアドレス {{email}} へ変更手続き中です。
    "パスワードを更新しました": "Password updated.", // パスワードを更新しました。
    "プロフィールを更新しました": "Your profile has been updated.", // プロフィールを更新しました。
    "グループの基本設定を更新しました": "Group preferences have been updated.", // グループの基本設定を更新しました。
    "グループを作成しました": "Group created.", // グループを作成しました。
    "テンプレートを削除してもいいですか": "Are you sure you want to delete {{name}}?", //  {{name}} を削除してもよろしいですか?
    "グループの公開範囲": "Group visibility", // グループの公開範囲
    "セクション/グループはありません": "There are no sections/groups", // グループがありません
    "ユーザ追加": "Add user", // ユーザを追加
    "新規ユーザを招待": "Invite new user", // 新規ユーザを招待
    "既存ユーザを追加": "Add existing user", // 既存ユーザを追加
    "既存ユーザを追加します": "Add another registered user.", // 既に他に登録済みのユーザを追加します。
    "メンバーは登録されていません": "Member is not registered.", // メンバーは登録されていません。
    "管理者": "Admin", // 管理者
    "一般ユーザ": "General user", // 一般ユーザ
    "一般ユーザに変更": "Change to general user", // 一般ユーザに変更
    "管理者に変更": "Change to admin", // 管理者に変更
    "管理者に変更します": "Change {{ name }} to a group admin.", //  {{name}} をグループ管理者に変更します。
    "一般ユーザに変更します": "Change {{ name }} to a general user.", //  {{name}} を一般ユーザに変更します。
    "通知する": "Notice", // 通知する
    "通知しない": "Do not notify", // 通知しない
    "リマインドを通知する": "Notify reminders", // リマインドを通知する
    "リマインドを通知しない": "Do not notify reminders", // リマインドを通知しない
    "すべてのリマインド通知を送らない": "Do not send all reminders", // すべてのリマインド通知を送らない
    "リマインドの通知を停止します": "Stop reminders for {{name}}.", //  {{name}} へのリマインド通知を停止します。
    "リマインドの通知を開始します": "Start a reminder to {{name}}.", //  {{name}} へのリマインド通知を開始します。
    "ユーザを追加しました": "{{name}} has been added to this group.", //  {{name}} さんをこのグループのメンバーに追加しました。
    "グループからユーザを削除しました": "{{name}} has been removed from this group.", //  {{name}} さんをこのグループのメンバーから外しました。
    "グループの管理権限を付与しました": "You have given {{ name }} control over this group.", //  {{name}} さんにこのグループの管理権限を付与しました。
    "グループの管理権限を削除しました": "Removed group management permissions for {{name}}.", //  {{name}} さんのグループ管理権限を削除しました。
    "ユーザへのリマインドメールの送信を開始します": "A reminder email has been sent to {{name}}.", //  {{name}} さんへのリマインドメールの通知を開始しました。
    "ユーザへのリマインドメールの送信を停止しました": "You have stopped sending reminders to {{name}}.", //  {{name}} さんへのリマインドメールの通知を停止しました。
    "ユーザを削除": "Remove from group members", // グループメンバーから外す
    "ユーザを削除してもいいですか": "Are you sure you want to remove {{ name }} as a member?", //  {{name}} さんをメンバーから外してもよろしいですか?
    "ユーザを削除しても過去の投稿は閲覧することができます": "You can still view past posts even if you leave the group.", // グループから外しても過去の投稿は閲覧することができます。
    "アカウント管理画面から操作": "If you want to completely delete from [gamba!] Due to retirement, you need to operate from the account management screen.", // 退職などで【gamba!】から完全に削除したい場合は、アカウント管理画面からも操作が必要です。
    "アカウント管理画面へ": "Go to account management screen", // アカウント管理画面へ
    "ユーザを選択": "Select user", // ユーザを選択
    "開始日": "Start date", // 開始日
    "終了日": "End date", // 終了日
    "翌期分自動作成": "Next term copy start", // 翌期分自動作成
    "Excelダウンロード": "Download in Excel format", // Excel形式でダウンロード
    "Googleアカウント": "Google Account", // Googleアカウント
    "アカウント": "Account", // アカウント
    "すべて抽出": "Extract all fields", // すべての入力項目を抽出
    "KPIを作成": "Create KPI", // KPIを作成
    "現在のKPI": "Current KPI", // 現在のKPI
    "終了したKPI": "Finished KPI", // 終了したKPI
    "PDFで保存": "Save as PDF", // PDFで保存
    "画像で保存": "Save as Image", // 画像で保存
    "KPIデータ設定": "KPI Data Settings", // KPIデータ設定
    "データ選択": "Data Selection", // データ選択
    "KPIを追加": "+ Add KPI", // KPIを追加
    "積み上げ": "Stacked", // 積み上げ
    "積み上げ説明": "Each KPI within a period can be displayed in a stacked graph to check cumulative trends.", // 積み上げ説明
    "個人データ": "Individual", // 個人データ
    "個人データ説明": "Track individual employee goal attainment and performance in real time.", // 個人データ説明
    "歩留まり": "Conversion rate", // 歩留まり
    "歩留まり説明": "The percentage of achievement between selected KPIs (e.g., number of interviews to number of contracts) is displayed as a percentage, allowing you to understand the efficiency of the process.", // 歩留まり説明
    "歩留まりライン": "100% Conversion line", // 100%歩留まりライン
    "比較": "Comparison", // 比較
    "比較説明": "Displays actual differences from the same period of the previous year, allowing the user to check growth rates and areas for improvement.", // 比較説明
    "比較説明メッセージ": "Displays one year of actual differences from the same period in the selected year.", // 比較説明メッセージ
    "使い方": "How To Use", // 使い方
    "並べ替え": "Sorting", // 並べ替え
    "並べ替えを終了": "Finish sorting", // 並べ替えを終了します。
    "並べ替え終了を選択": "When editing the KPI, select the End Sorting button.", // KPIを編集する際は「並べ替えを終了する」ボタンを選択してください。
    "ドラッグして並べ替え": "You can rearrange the display order by dragging.", // ドラッグして表示の順序の並べ替えができます。
    "長押しして並べ替え":"Press and hold to rearrange the display order", // 長押しして表示の順序の並べ替えができます。
    "割り当てられていません": "Not assigned", // 割り当てられていません
    "目標値": "Target value: {{ value }}", // 目標値
    "目標値2": "Target value", // 目標値
    "担当者": "Rep", // "担当者
    "担当者の実績": "{{name}} achievements", //  {{name}} の実績
    "KPIは登録されていません": "KPI is not registered.", // KPIは登録されていません。
    "コピーして新規作成": "Copy and create new", // コピーして新規作成
    "コピーして翌期分を作成": "Copy to create next period", // コピーして翌期分を作成
    "コピー": "(copy)", // (コピー)
    "データごと削除": "Delete every data", // データごと削除
    "KPIを削除しました": "{{name}} deleted", //  {{name}} を削除しました
    "KPIを削除してもいいですか": "Are you sure you want to delete {{name}}?", //  {{name}} を削除してもよろしいですか?
    "実績値の集計方法": "Aggregation method of actual values", // 実績値の集計方法
    "プレビュー": "Preview", // プレビュー
    "プレビュー説明":"You will see the below table on the timeline.", //
    "実績値を期間内で累計する": "Accumulate actual values within a period", // 実績値を期間内で累計する
    "実績値を日毎に集計する": "Aggregate actual values daily", // 実績値を日毎に集計する
    "実績値を期間内で累計の説明": "The entered actual values are accumulated within the period, and the achievement rate for the target value is calculated. This is usually selected for monthly sales goals.", // 入力した実績値を期間内で累計し、目標値に対する達成率を計算します。月間売上目標など、通常はこちらを選択します。
    "実績値を日毎に集計の説明": "The actual value entered is not accumulated, and the achievement rate is calculated for the daily target value. Select here for the number of calls per day.", // 入力した実績値は累計せず、日ごとの目標値に対して達成率を計算します。日ごとの架電件数目標などは、こちらを選択します。
    "月次グラフ": "Monthly graph", // 月次グラフ
    "日次グラフ": "Daily graph", // 日次グラフ
    "年次": "Yearly", // 年次
    "月次": "Monthly", // 月次
    "日次": "Daily", // 日次
    "集計期間": "Aggregation period", // 集計期間
    "集計日": "Aggregation date", // 集計日
    "グラフを表示": "Show graph", // グラフを表示
    "KPI名": "KPI name", // KPI名
    "その他のKPI": "Other KPIs", // その他のKPI
    "KPI名の説明": "Sales, profits, contracts, etc.", // 売上・利益・契約件数など
    "期間": "Period", // 期間
    "単位": "Unit", // 単位
    "単位の説明": "Yen, matter, company, etc.", // 円・件・社など
    "単位の表示位置": "Unit diplay position",     //単位の表示位置
    "値の前に表示": "Show before value", // 値の前に表示
    "値の後に表示": "Show after value", // 値の後に表示
    "表示形式": "Value display format", // 値の表示形式
    "担当者と目標値の割り当て": "Assign people and goals", // 担当者と目標値の割り当て
    "すべて選択": "Select all", // すべて選択
    "すべて解除": "Unselect all", // すべて解除
    "同じ値を設定": "Set the same value", // 同じ値を設定
    "目標値を入力": "Enter target value", // 目標値を入力
    "KPIを更新しました": "{{name}} has been updated.", //  {{name}} を更新しました。
    "KPIを作成しました": "KPI created.", // KPIを作成しました。
    "KPIがありません": "KPI is not registered.", // KPIが登録されていません。
    "開始日は終了日より前に設定してください": "Start date must be before end date.", // 開始日は終了日より前に設定してください。
    "自動作成日は開始日より後に設定してください": "Automatic creation date must be before start date." ,//自動作成日は終了日より後に設定してください
    "自動作成日は終了日より前に設定してください": "Automatic creation date must be before end date.", //自動作成日は終了日より前に設定してください
    "リマインド通知": "Remind notifications", // リマインド通知
    "リマインド": "Remind", // リマインド
    "リマインド通知時刻": "Reminder notification time", // リマインドの通知時刻
    "時ごろに通知": "Notify around {{time}}", //  {{time}} ごろに通知
    "リマインド通知日": "Day of the reminder notice", // リマインド通知の曜日
    "send_on_sun": "Sunday", // 日曜日
    "send_on_mon": "Monday", // 月曜日
    "send_on_tue": "Tuesday", // 火曜日
    "send_on_wed": "Wednesday", // 水曜日
    "send_on_thu": "Thursday", // 木曜日
    "send_on_fri": "Friday", // 金曜日
    "send_on_sat": "Saturday", // 土曜日
    "send_on_holiday": "Holidays", // 祝祭日
    "個別リマインド通知": "Individual settings",   // リマインド通知の個別設定
    "リマインド通知の送信スケジュールを変更しました": "The schedule for sending remind notifications has been changed.", // リマインド通知の送信スケジュールを変更しました。
    "検索キーワード": "Search keyword", // 検索キーワード
    "検索": "Search", // 検索
    "ユーザで絞り込み": "Filter by user", // ユーザで絞り込み
    "すべての投稿種別": "All post types", // すべての投稿種別
    "日報のみ": "Daily report only", // 日報のみ
    "KPIのみ": "KPI only", // KPIのみ
    "ノートのみ": "Notes only", // ノートのみ
    "オプション": "Optional",
    "添付ファイル付き": "With attachment", // 添付ファイル付き
    "いいねした投稿": "Liked posts",
    "すべての期間の投稿": "Posts of all periods", // すべての期間の投稿
    "日付の選択": "Select date", // 日付の選択
    "投稿日": "Posted date", // 投稿日
    "より後の投稿": "After {{report_at}}", //  {{date}} より後
    "読み込み中": "Loading...", // 読み込み中...
    "名前で検索": "Search by name ...", // 名前で検索...
    "選択してください": "Please select", // 選択してください
    "選択されていません": "Not selected", // 選択されていません
    "選択": "Choice", // 選択
    "取り消し": "Cancel", // 取り消し
    "閉じる": "Close", // 閉じる
    "キャンセル": "Cancel", // キャンセル
    "はい": "Yes!", // はい!
    "いいえ": "No", // いいえ
    "OK": "OK", //OK
    "すべてのグループ": "All posts", // すべての投稿
    "グループ": "Groups", // グループ
    "公開グループ": "Public groups", // 公開グループ
    "非公開グループ": "Private groups", // 非公開グループ
    "その他": "その他",
    "組織": "Organizations", // 組織
    "公開グループの説明": "All users in the account can view the post.", // アカウント内のすべてのユーザが投稿を閲覧できます。
    "非公開グループの説明": "Only members of the group can view the post.", // グループのメンバーのみが投稿を閲覧できます。
    "グループを探す": "Find a group", // グループを探す
    "隠す": "Hide", // 隠す
    "すべて表示": "View all", // すべて表示
    "表示を隠す": "Hide display", // 表示を隠す
    "もっと見る" : "See more", //もっと見る
    "続きを表示": "Show more", // 続きを表示
    "件のコメントをすべて表示": "Show previous {{ count }} comments",
    "が返信しました": " replied・{{ count }} replies",
    "が返信しました(1件)": " replied",
    "件のコメントをすべて表示_plural": "Show {{ count }} comments",
    "件の返信をすべて表示_plural": "Show {{ count }} replies",
    "コメントを隠す": "Hide comments",
    "返信を隠す": "Hide replies",
    "テンプレートを選択": "Select template", // テンプレートを選択
    "テンプレート":"template", //テンプレート
    "テンプレートを編集" : "Edit template", //テンプレートを編集
    "user_templates_setting": "Creating Your Own Template", // 自分専用テンプレートを作成する
    "group_templates_setting": "Creating a group common template", // グループ共通テンプレートを作成する
    "下書き": "Draft ({{ count }})",
    "下書きを選択": "Select draft",
    "全て削除": "Delete All", // 全て削除
    "入力フィールド": "Easy input items", // かんたん入力項目
    "form-dropdown": "Select from menu", // メニューから選択
    "form-text": "Text description (multiple lines)", // テキスト記述(複数行)
    "form-string": "Text description (1 line)", // テキスト記述(1行)
    "form-numeric": "Numeric input", // 数値入力
    "form-date": "Date input", // 日付入力
    "form-time": "Time input", // 時刻入力
    "フィールドを追加": "Add input item", // 入力項目を追加
    "値": "Item value", // 項目の値
    "必須": "Required input", // 必須入力
    "フィールド種別": "Input type", // 入力種別
    "フィールド名": "Input item name", // 入力項目名
    "値を入力してください": "Please fill in the value", // 値を入力してください
    "未入力": "No value entered", // 未入力
    "新しいフィールド": "New input item", // 新しい入力項目
    "フィールドの選択肢": "Menu choices", // メニューの選択肢
    "ドロップダウン入力の場合の選択肢を改行で区切って列挙します": "Lists menu options, one per line.", // メニューの選択肢を1行ごとに列挙します。
    "初期値を指定します": "Specify the initial value", // 初期値を指定します
    "初期値": "Initial value", // "初期値
    "絵文字を入力": "Enter emoji", // 絵文字を入力
    "終日": "All day", // 終日
    "投稿種別を選択": "Select type", // 投稿種別
    "日報にコピー": "Paste", // 貼付け
    "投稿作成":"Create Post", //投稿作成
    "投稿を編集": "Edit post", // 投稿を編集
    "投稿を報告": "Report post", // 投稿を報告
    "投稿を削除": "Delete post", // 投稿を削除
    "投稿を印刷": "Print post", // 投稿を印刷
    "投稿を翻訳": "Translate post", // 投稿を翻訳
    "ピン留めされた投稿": "Pinned post", // ピン留めされた投稿
    "ピン留め": "Pin", // ピン留め
    "ピン留め解除": "Unpin", // ピン留め解除
    "ピン留め説明": "The post will be pinned to the top of the group timeline. Would you like to pin it?", // ピン留め
    "ピン留め解除説明": "Would you like to undo the unpinning?", // ピン留め解除
    "元の表示に戻す": "Show original post", // 元の表示に戻す
    "翻訳": "(translated)", // (翻訳)
    "リンクをコピー": "Copy link", // リンクをコピー
    "本文をコピー": "Copy text", // 本文をコピー
    "ユーザブロック": "Block User", // ユーザをブロック
    "ユーザブロック解除": "Unblock User", // ユーザをブロック解除
    "投稿ブロック": "Block diary", // 投稿をブロック
    "投稿ブロック解除": "Unblock diary", // 投稿をブロック解除
    "クリップボードにコピー": "Copy to clipboard", // クリップボードにコピー
    "宛先を追加": "Add recipient", // 宛先を追加
    "編集済み": "(Edited)", // (編集済み)
    "編集時刻": "(Edit to {{updated}})", // ( {{updated}} に編集)
    "他n人": "and {{n}} ", // 他{{n}}人
    "n" : "{{ n }}", // {{ n }}
    "n人": "{{n}}person ", // {{n}}人
    "複数n人": "{{n}}persons ", // 複数{{n}}人
    "がいいね": "Like !.", // がいいね!.
    "が開封": " Opened.", // が開封.
    "開封n": "{{ n }} Opened.", //開封n
    "開封n < 3": "Opened ", //開封n < 3
    "が読んでみて": "Read on! from", // から読んでみて!
    "に読んでみて": "Read on!", // に読んでみて!
    "返信要求付き": "(Reply required)", // (要返信)
    "がコメント": " comment", //がコメント
    "n件": "{{ n }} comment", //n件
    "クリックしてもっと見る": "See more attached photos ...", // 添付写真をもっと見る...
    "他n個の添付写真を開く": "See all {{ n }} other attached photos ...", // 他 {{n}} 個の添付写真をすべて見る...
    "開封": "Opened", // 開封
    "投稿": "Posts", // 投稿
    "リアクション": "Reactions", // リアクション
    "投稿数": "N. of Posts", // 投稿数
    "リアクション数": "N. of Reactions", // リアクション数
    "1人平均": "Per users", // 1人平均
    "投稿あたり": "Per posts", // 投稿あたり
    "平均投稿数": "Avg. Posts", // 平均投稿数
    "平均リアクション数": "Avg. Reactions", // 平均リアクション数
    "いいね": "Like !", // いいね!
    "ピン": "Pin", // ピン
    "got_it": "Got it！", // got_it
    "good_job": "Good job！", // good_job
    "thanks": "Thanks！", // thanks
    "good_luck": "Good luck！", // good_luck
    "regards": "Regards！", // regards
    "excellent": "Excellent！", // excellent
    "disappointed": "Disappointed！", // disappointed
    "いいねを取り消す": "Undo Like !", // 取り消す
    "いいねといっている人はまだいません": "No one likes it yet.", // いいねといっている人はまだいません。
    "読んでみてといっている人はまだいません": "No one has read it on yet.", // 読んでみてといっている人はまだいません。
    "開封した人はまだいません": "No one has opened it yet.", // 開封した人はまだいません。
    "コメントした人はまだいません": "No one has comment it yet.", // コメントした人はまだいません。
    "返信した人はまだいません": "No one has reply it yet.", // 返信した人はまだいません。
    "時間前に開封": "{{timestamp}} opened", //  {{timestamp}} に開封
    "時間前にいいね": "Like for {{timestamp}}", //  {{timestamp}} にいいね!
    "時間前にリアクション": "{{ n }} for {{ timestamp }}", //時間前にリアクション
    "時間前に送信": "Sent to {{timestamp}}", //  {{timestamp}} に送信
    "時間前に返信": "Replied to {{timestamp}}", //  {{timestamp}} に返信済み
    "時間前にコメント": "Comment to {{ timestamp }}", // {{ timestamp }}にコメント
    "時間前に返信(tab)": "Replied to {{ timestamp }}",  // {{ timestamp }}に返信
    "ユーザのコメント": "{{name}} comments", //  {{name}} のコメント
    "コメント": "Comment", // コメント
    "コメントを削除": "Delete Comment",
    "コメントを編集": "Edit Comment",
    "スタンプ": "Stamp", // スタンプ
    "スタンプ追加": "Add stamp", // スタンプ追加
    "を削除します": "Delete", // を削除します
    "読んでみて": "Read it!", // 読んでみて!
    "読んでみての宛先を追加": "Read on! Add recipients", // 読んでみて! の宛先を追加
    "返信を要求": "Request a reply", // 返信を要求する
    "保存された投稿を削除してもいいですか": "Are you sure you want to delete the temporarily saved post?", // 一時保存されている投稿を削除してもよろしいですか?
    "保存された全ての投稿を削除してもいいですか": "Are you sure you want to delete the all temporarily saved posts?", // 一時保存されている投稿を削除してもよろしいですか?
    "この投稿は削除されました" : "This post has been deleted", // この投稿は削除されました
    "日報を削除してもいいですか": "Are you sure you want to delete this post?", // この投稿を削除してもよろしいですか?
    "コメントを削除してもいいですか": "Are you sure you want to delete this comment?", // このコメントを削除してもよろしいですか?
    "この操作は取り消せません": "This operation cannot be undone. Please be careful.", // この操作は元に戻せません。ご注意ください。
    "この投稿を通報してもよろしいですか": "Are you sure you want to report this post?", // この投稿を通報してもよろしいですか?
    "このコメントを通報してもよろしいですか": "Are you sure you want to report this comment?", // このコメントを通報してもよろしいですか
    "このユーザを通報してもよろしいですか": "Are you sure you want to report this user?", // この投稿を通報してもよろしいですか?
    "コメントを入力してください": "Please enter a comment.", // コメントを入力してください。
    "投稿がありません": "There are no posts.", // 投稿がありません。
    "フォルダがありません": "There is no folder.", // フォルダがありません
    "一番最後の投稿です": "There are no previous posts.", // これより以前の投稿はありません。
    "よろしいですか？": "Is it OK?", // よろしいですか？
    "テンプレート名": "Template name", // テンプレート名
    "テンプレートをインポート": "Import", // テンプレートをインポート
    "テンプレートを上書きしていいですか": "Overwrite with the template?", // 現在編集中の内容を選択したテンプレートで上書きしてもよろしいですか?
    "テンプレートを作成しましょう": "Let's create a template.", // テンプレートを作成しましょう。
    "テンプレートを作成しました": "Template created.", // テンプレートを作成しました。
    "テンプレートを更新しました": "{{name}} has been updated.", //  {{name}} を更新しました。
    "テンプレートを削除しました": "{{name}} has been deleted.", //  {{name}} を削除しました。
    "テンプレートは登録されていません": "The template has not been registered.", // テンプレートは登録されていません。
    "お気に入りグループに追加しました": "I followed {{name}}.", //  {{name}} をフォローしました。
    "お気に入りグループから削除しました": "You have unfollowed {{name}}.", //  {{name}} のフォローを外しました。
    "お気に入りユーザに追加しました": "I followed {{name}}.", //  {{name}} をフォローしました。
    "新着メッセージがあります": "You have a new message from {{name}}.",
    "お気に入りユーザから削除しました": "You have unfollowed {{name}}.", //  {{name}} のフォローを外しました。
    "投稿をブロックしました": "You block {{ name }}.",  // {{ name }}の投稿をブロックしました。
    "投稿をブロック解除しました": "You unblock {{ name }}.",  // {{ name }}の投稿をブロック解除しました。
    "ユーザをブロックしました": "You block {{ name }}.",  // {{ name }}をブロックしました。
    "ユーザをブロック解除しました": "You unblock {{ name }}.",  // {{ name }}をブロック解除しました。
    "ブロックされたユーザはありません": "There are no blocked users.", // ブロックされたユーザはいません。
    "ブロックされたユーザ": "Blocked users", // ブロックされたユーザ
    "お気に入り登録されたユーザはありません": "There are no followers.", // フォローしているユーザはいません。
    "お気に入り登録されたグループはありません": "There are no groups you are following.", // フォローしているグループはありません。
    "すでにフォロー設定済みです": "You have already set up follow.", // すでにフォロー設定済みです。
    "自身のフォローはできません": "You cannot follow yourself.", // 自身のフォローはできません。
    "投稿があった時": "When a daily report, KPI, or note is posted", // 日報やKPI・ノートの投稿があった時
    "コメントがあった時": "When there is a comment on my post", // 自分の投稿にコメントがあった時
    "いいねがあった時": "When you like something on your post", // 自分の投稿にいいね!があった時
    "投稿があった時app": "投稿",  // 投稿
    "コメントがあった時app": "自分の投稿へのコメント",　　// 自分の投稿へのコメント
    "いいねがあった時app": "自分の投稿へのいいね",     // 自分の投稿へのいいね
    "返信があった時": "When you reply to your likes or comments", // 自分のいいね!やコメントに返信があった時
    "読んでみてがあった時": "When you read!", // 読んでみて!が自分に送られた時
    "読んでみてが開封された時": "When your mention is opened", // 自分の送った読んでみて！が開封された時
    "お気に入りに投稿があった時": "When a post is made to a group / user that you are following", // フォローしているグループ/ユーザに投稿があった時
    "チャットを受信した時": "When a chat is received", // チャットを受信した時
    "返信があった時app": "いいね！やコメント返信",  // いいね！やコメント返信
    "読んでみてがあった時app": "読んでみて！",      // 読んでみて！
    "読んでみてが開封された時app": "When mention is opened", // 読んでみて！の開封通知
    "お気に入りに投稿があった時app": "フォロー先での投稿",   // フォロー先での投稿
    "チャットを受信した時app": "チャット",   // チャット
    "通知none": "Do not notify", // 通知しない
    "通知mail": "Notify email", // メールに通知
    "通知push": "Notify app", // アプリに通知
    "通知all": "Notify all", // すべてに通知
    "メール": "Mail",       // メール
    "アプリ": "App",       // アプリ
    "共通設定": "Common setting", // 共通設定
    "通知スケジュールを設定する": "Set up a notification schedule", // 通知スケジュールを設定する
    "通知スケジュールを設定文言": "You will receive notifications at the time set here. Notifications will be paused at other times.", // 通知スケジ
    "時間": "Time", // 時間
    "各グループの通知設定": "Group notification settings", // グループの通知設定
    "グループの通知設定を変更しました": "Notification settings for {{ name }} have been changed.", //  {{name}} への通知設定を変更しました。
    "通知設定を変更しました": "Notification settings changed.", // 通知設定を変更しました。
    "一括変更しました": "Notification settings for all groups have been changed collectively.", // 全グループの通知設定を一括変更しました。
    "チャット通知設定": "Chat Notification (toast display)",
    "通知を表示": "New Message",
    "内容を表示": "View Content",
    "通知": "Notification", // 通知
    "gambaから": "From gamba!", // gamba!から
    "通知がありません": "You have no notifications.", // 通知がありません。
    "一括設定": "Apply to all groups", // 全グループに適用
    "一括設定説明": "すべてのグループのアプリ通知、メール通知設定を一括で切り替えます。", // すべてのグループのアプリ通知、メール通知設定を一括で切り替えます。
    "昨日の日報": "Copy previous daily report", // 前回の日報をコピー
    "昨日の投稿内容": "Copy the previous post", // 前回の投稿内容をコピー
    "検索条件": "Search condition", // 検索条件
    "保存された検索条件": "Saved search conditions", // 保存された検索条件
    "検索条件を保存": "Save this condition", // この条件を保存
    "保存": "Save", // 保存
    "新しい検索条件": "New search criteria", // 新しい検索条件
    "検索条件を削除" : "Delete search criteria", //検索条件を削除
    "検索条件を編集" : "Edit search criteria",
    "検索条件を削除してもいいですか": "Are you sure you want to delete {{name}}?", //  {{name}} を削除してもよろしいですか?
    "ノートのタイトル": "Title (example)", // "タイトル (例
    "検索条件を削除しました": "{{name}} has been deleted.", //  {{name}} を削除しました。
    "検索条件を保存しました": "The search conditions have been saved.", // 検索条件を保存しました。
    "チャットの履歴がありません": "No chat history.", // チャットの履歴がありません。
    "チャットを開始": "Start chat", // チャットを開始
    "チャットの宛先を追加": "Add chat destination", // チャットの宛先を追加
    "メンバーを追加": "Add member", // メンバーを追加
    "メンバーを削除": "Remove {{ name }} from this chat.", //  {{name}} をこのチャットから削除します。
    "チャットルームから削除": "{{name}} has been removed from the chat room.", //  {{name}} をチャットルームから削除しました。
    "チャットルームを削除します": "This chat timeline will be deleted.", // チャットの履歴もすべて削除されます。
    "チャットルームを削除していいですか": "Are you sure you want to delete the chat room?", // チャットルームを削除してもよろしいですか？
    "チャットルームを削除しました": "Chat with {{ name }} has been deleted.", //  {{name}} とのチャットを削除しました。
    "グループをごみ箱に移動": "This group will be moved to trash.",      // このグループがごみ箱に移動されます。
    "グループをごみ箱に移動してもよろしいですか":"Are you sure you want to move the group to trash?",  // グループをごみ箱に移動してもよろしいですか？
    "ごみ箱に移動トースト": "Moved the {{ name }} group to the trash.",  // {{ name }}のグループをごみ箱に移動しました。
    "この操作はグループに参加している全てのユーザーに影響します" : "This operation affects all users participating in the group.",// この操作はグループに参加している全てのユーザーに影響します。
    "この操作はグループに参加している全てのユーザーに影響します(復元説明付)" : "この操作はグループに参加している全てのユーザーに影響します。グループを完全に削除もしくは復元するには、アカウント管理画面で「完全に削除」「ごみ箱から戻す」の操作が必要です。",  //  この操作はグループに参加している全てのユーザーに影響します。グループを完全に削除もしくは復元するには、アカウント管理画面で「完全に削除」「ごみ箱から戻す」の操作が必要です。
    "完全削除復元説明文": "To delete completely or restore a group, you need to do the operations of \"Permanently delete\" or \"Return from trash\" on the account management screen.",  // グループを完全に削除もしくは復元するには、アカウント管理画面で「完全に削除」「ごみ箱から戻す」の操作が必要です。
    "このチャットは終了しました": "This chat is over.", // このチャットは終了しています。
    "この操作はチャットルームに参加している全てのユーザーに影響します" : "This operation affects all users participating in the chat room",// この操作はチャットルームに参加している全てのユーザーに影響します
    "ユーザとのチャット": "Chat with {{name}}", //  {{name}} とのチャット
    "既読n": "Open {{ n }}", // 既読 {{n}}
    "メッセージを削除": "Delete the message.", // メッセージを削除します。
    "メッセージを削除": "Delete message",  // メッセージを削除
    "メッセージをコピー": "Copy message",  // メッセージをコピー
    "メッセージを入力してください": "Please enter a message", // メッセージを入力してください。
    "メッセージがありません": "There are no messages.", // メッセージがありません。
    "KPIの実績値を更新しました": "{{reported_at}} {{ name }} achievement values have been updated.", //  {{reported_at}} の {{name}} の実績値を更新しました。
    "この値は変更できない": "Since you are not a member of {{ group_name }} group, you cannot change the value.", //  {{ group_name }}グループのメンバーではないので、値を変更することはできません。
    "アップロード中": "Uploading ...", // アップロード中...
    "クリップボードにコピーしました": "Copied to clipboard.", // クリップボードにコピーしました。
    "最新版に更新します": "You need to update to the latest version.", // 最新版に更新する必要があります。
    "再読み込み": "Reload", // 再読み込み
    "ここをクリックして招待してみよう": "Click here to invite your employees to gamba!", // ここをクリックして、社員のみなさんをいますぐgamba!に招待しましょう。
    "ここをクリックして日報を投稿してみよう": "Click 'Use Template' to post a sample daily report now.", // 「テンプレートを使う」をクリックして、いますぐサンプルの日報を投稿してみましょう。
    "名前を変更": "Rename", // 名前を変更
    "チャットルーム名を変更": "Changed to {{name}}.", //  {{name}} に変更しました。
    "チャットルーム名": "Chat room name", // チャットルーム名
    "カレンダーを開く": "Open calendar", // カレンダーを開く
    "ファイルの添付": "Attach files", // ファイルを添付する
    "カメラで撮影": "Take a photo", // カメラで撮影
    "写真動画を選択": "Select Image / Movie", // 写真・動画を選択
    "削除したメンバーのみを表示": "Show only deleted members", // 削除したメンバーのみを表示
    "Googleドキュメント": "Google Docs", // Googleドキュメント
    "Googleドキュメントに接続": "Connect to Google Docs", // Googleドキュメントに接続
    "退室": "Exit", // 退室
    "削除": "Delete", // 削除
    "ブロック": "Block", // ブロック
    "ブロック解除": "Unblock", // 解除
    "上書き": "Overwrite", //上書き
    "外す": "Remove",  //外す
    "チャットルーム設定": "Chat room settings", // チャットルーム設定
    "退室してもいいですか": "Are you sure you want to leave the chat room?", // チャットルームから退室してもよろしいですか?
    "退室しました": "You have left the chat room.", // チャットルームから退室しました。
    "別ウィンドウで表示": "Display in another window", // 別ウィンドウで表示
    "次ページへ": "To the next page", // 次ページへ
    "前ページへ": "To previous page", // 前ページへ
    "拡大": "Expansion", // 拡大
    "縮小": "Reduction", // 縮小
    "元に戻す": "Undo", // 元に戻す
    "投稿の取得に失敗しました": "Post retrieval failed.", // 投稿の取得に失敗しました。
    "通知の取得に失敗しました": "Failed to get notification.", // 通知の取得に失敗しました。
    "添付ファイルの取得に失敗しました": "Acquisition of the attached file failed.", // 添付ファイルの取得に失敗しました。
    "メンバーの取得に失敗しました": "Failed to get members.", // メンバーの取得に失敗しました。
    "データの取得に失敗しました": "Acquisition of data failed.", // データの取得に失敗しました。
    "KPIの取得に失敗しました": "KPI acquisition failed.", // KPIの取得に失敗しました。
    "日報提出状況の取得に失敗しました": "Failed to get daily report submission status.", // 日報提出状況の取得に失敗しました。
    "チャットルームの取得に失敗しました": "Failed to get chat room.", // チャットルームの取得に失敗しました。
    "メッセージの取得に失敗しました": "Failed to get message.", // メッセージの取得に失敗しました。
    "Googleカレンダーの取得に失敗しました": "Failed to get Google Calendar.", // Googleカレンダーの取得に失敗しました。
    "Outlookカレンダーの取得に失敗しました":"Failed to get Outlook Calendar.", // Outlookカレンダーの取得に失敗しました。
    "予定がないため貼付けできません":"I can't paste because I have no plans", //予定がないため貼付けできません
    "メンバー入室": "{{name}} has joined.", //  {{name}} が参加しました。
    "メンバー退室": "{{name}} has left.", //  {{name}} が退室しました。
    "フォトライブラリに保存しました": "The attached image has been saved.", // 添付画像を保存しました。
    "LINEで招待": "Invite with LINE", // LINEで招待
    "メールで招待": "Invite by email", // メールで招待
    "表示しない": "Do not show again", // 今後、表示しない
    "招待メッセージ": "Invite to gamba! \nClick the link below to register.", // 「日報共有アプリgamba!」に招待します。以下のリンクをクリックして登録してください。
    "ウェルカムメッセージ": "Web Consulting For Free", //無料Webコンサルティング実施中
    "無料ウェブ説明": "We will create daily report templates that suits your company!", // 貴社に合った日報テンプレートをお作りします！
    "ウェブ説明詳細": "Basic operation explanation is also OK!\nPlease feel free to apply.", // 基本的な操作説明もOK！お気軽にお申込みください。
    "ウェブ説明予約": "book the web consulting\n(launch browser)", // WEBコンサルティングを予約する
    "ウェブ説明予約(WEB版)": "book the web consulting",
    "メールSubject": "{{name}} has sent you an invitation to the daily report sharing app gamba !.", // {{name}}さんから「日報共有アプリgamba!」への招待が届いています。
    "投稿を見る": "View posts", // 投稿を見る
    "月次提出推移": "Monthly number of posts", // 日報提出数の月次推移
    "日報提出状況": "Submission status", // 日報提出状況
    "前月": "Previous", // 前月
    "翌月": "Next", // 翌月
    "月間サマリー": "{{name}} Submission status", //  {{name}} 　日報提出状況
    "月間日報提出状況を表示": "View monthly submission status", // 月間の日報提出状況を見る
    "月": "Mon", // 月
    "火": "Tue", // 火
    "水": "Wed", // 水
    "木": "Thu", // 木
    "金": "Fri", // 金
    "土": "Sat", // 土
    "日": "Sun", // 日
    "合計": "Total", // 合計
    "年月": "{{ year }} {{ month }}", //  {{year}}  年  {{month}}  月
    "日報アイコン": ":Daily report", // ：日報
    "KPIアイコン": ":KPI", // ：KPI
    "ノートアイコン": ":Note", // ：ノート
    "トライアル期間が終了しました": "The free trial period has expired.", // 無料トライアル期間が終了しました。
    "トライアルの有効期限": "Trial Expiration Date", // トライアルの有効期限
    "残りX日": "Remaining {{ dates }} days", // 残りX日
    "プラン変更": "Change Plan", // プラン変更
    "トライアル最終日です": "It is the last day of the free trial period.", // トライアル最終日です
    "gamba!をご利用いただきありがとうございました": "Thank you for using gamba !.", // gamba!をご利用いただきありがとうございました
    "引き続き利用するには契約が必要です": "To continue using the service, you need to apply for a contract.", // 引き続きご利用いただくためには、契約のお申し込みが必要です。
    "契約する": "Apply for a contract now", // いますぐ契約を申し込む
    "タイムゾーン": "Timezone",
    "言語": "Language",
    "通知アイコン":"Notification",　// 通知
    "日報提出状況アイコン": "Diaries", // 提出状況
    "KPI進歩状況アイコン": "KPI", // KPI
    "チャットアイコン": "Chat", // チャット
    "MAXページまでを表示しています": "Showing from 1 to 50 page only.", // 1〜50ページまでを表示しています。これ以降はファイルをダウンロードしてご覧ください。
    "KPIを選択してください" : "Please select a KPI", // KPIを選択してください
    "KPIが選択されていません" : "KPI not selected", // KPIが選択されていません
    "投稿種別" : "Post type", //投稿種別
    "文字サイズ変更" : "Change the font size", //文字サイズ変更
    "端末設定が開きます。よろしいですか？" : "The terminal settings will open. Is it OK ?", //端末設定が開きます。よろしいですか？
    "プロフィールを編集" : "Edit profile", //プロフィールを編集
    "自己紹介" : "self-introduction", //自己紹介
    "プロフィールテンプレートを使用する" : "Use profile template", //プロフィールテンプレートを使用する
    "プロフィールを登録する" : "Register a profile", //プロフィールを登録する
    "プロフィールテンプレート" : "Use a profile template. Is it OK?", // プロフィールインポート
    "編集内容破棄タイトル": "The content is not {{ name }}. Do you want to discard?",  // 編集中の内容が登録されていません。破棄しますか？"
    "編集内容破棄説明": "To register, press Cancel and press the {{ name }} button.",   // 登録するにはキャンセルを押して「登録」ボタンを押してください。
    "破棄": "Discard",   // 破棄
    "投稿の編集が完了しました" : "Post editing is complete", //投稿の編集が完了しました
    "投稿しました" : "I posted.", //投稿しました
    "お客様のトライアル期間は終了しました" : "Your trial period has expired.", //お客様のトライアル期間は終了しました。
    "再度利用するにはもう一度トライアルをしてください" :  "Thank you for using gamba !. You can try again for free by registering again. Please apply from 「Start Free Trial」 at the bottom.", //gamba!をご利用いただきありがとうございました。改めてご登録いただくことで再び無料トライアルが可能です。下部の「無料トライアルを始める」よりお申し込みください。
    "【アプリ】再度利用するにはもう一度トライアルをしてください" :  "Thank you for using gamba !. You can try again for free by registering again.", //gamba!をご利用いただきありがとうございました。改めてご登録いただくことで再び無料トライアルが可能です。
    "ご契約を希望のお客様" : "If you would like to make a contract, ", //ご契約を希望のお客様は
    "こちら" : " here.", //こちら
    "お申し込みください" : " please apply from", //お申し込みください
    "無料トライアルを始める" : "Start a free trial", //無料トライアルを始める
    "全ての端末でログアウト" : "Log out on all devices" , // 全ての端末でログアウト
    "入力内容不備" : "There is something wrong with the input content.", // 入力内容不備
    "リアクション" : "Reaction", //リアクション
    "下書き保存" : "Draft saving is complete.", //下書き保存
    "他n件のKPIをすべて表示": "Show all other {{ n }} KPIs", //他n件のKPIをすべて表示
    "対象ユーザーはこのグループに所属していません" : "Target user does not belong to this group." ,
    "通知設定" : "Notification settings" , //通知設定
    "対応するアプリがない" : "I can't open the file because there is no corresponding app. \nPlease check the support site for details.", //対応するアプリがないため、ファイルを開けません 詳細はサポートサイトをご確認ください。
    "ファイルを開けません" : "File cannot be opened", //ファイルを開くことができません。
    "サポートサイトを開く" : "Open the support site", //サポートサイトを開く
    "ファイルはまだ処理中" : "Your file is still being processed. Please try again later.", //このファイルはまだ処理中です。しばらくしてからもう一度お試しください。
    "ファイルが読み込めない" : "This file cannot read.", //このファイルは読み込めません。
    "グループ所属" : "Show group members only", //グループメンバーのみ表示
    "グループ(未読)" : "Groups (unread)", //グループ(未読)
    "未読のみ表示" : "Show unread only", //未読のみ表示
    "未読グループがありません" : "No unread groups", //未読グループがありません
    "提出予定" : "Submission schedule", //提出予定
    "月間サマリー編集モード": "{{ name }}　Daily Report Submission Status/Edit",
    "提出予定登録説明" : "If you check the box, the submission schedule will be registered.", //提出予定登録説明
    "提出予定登録" : "Submission schedule has been registered.", //提出予定登録
    "平日をすべて選択" : "Select all weekdays", //平日をすべて選択
    "リニューアル": "Under renewal.\nPlease wait for a while.", // リニューアル中。\n今しばらく、お待ちください。
    "リニューアル中": "Under renewal.", // リニューアル中。
    "お待ちください": "Please wait for a while", //今しばらく、お待ちください。
    "レポート": "Report",
    "日報の提出予定人数": "Number of people expected to submit daily reports",
    "週間レポート": "Weekly report",
    "月間レポート": "Monthly report",
    "週間レポートを出力する": "Print weekly report",
    "月間レポートを出力する": "Print monthly report",
    "週間レポート出力開始日": "Weekly report output start date",
    "月間レポート出力開始日": "Monthly report output start date",
    "レポート設定を更新しました": "Report settings have been updated",
    "日報の提出数がなし": "There were no posts during this period. Please contact gamba! management to consider how to operate it!",
    "日報の提出数が90%以上": "That's a great posting rate! Let's continue like this!",
    "日報の提出数が増加": "It's better than the previous period! Let's aim for a posting rate of 90%!",
    "日報の提出数が減少": "Posts have decreased from the previous period. We look forward to your posts!",
    "レスポンスなし": "There seems to be no response. First, click “Like!”!",
    "日毎集計": "Daily Total", 
    "累計説明": "Displays a cumulative graph of actual values during the period.", 
    "文字の大きさ": 'Font size',
    "文字サイズ設定" : "Setting the font size",
    "文字サイズが保存されました": "The font size has been saved.",
    "グループ内の投稿数": "・Number of posts in the group: {{posts}} posts",
    "先月との投稿数の変化": "Comparison of submission rates with last month",
    "投稿なし": "No posts found. If you have any questions or concerns about gamba!, please feel free to contact our support team!",
    "投稿数50%未満": "More than half of the team has not posted yet. Even today's events or small realizations are OK! Why not share them?",
    "投稿数50-89%": "The posting rate is steady! We're just one step away from reaching 90%. Let's aim to share information with the whole team!",
    "投稿数90%以上": "Great posting rate! The whole team is able to share information!✨",
    "具体的な提出状況":" Please see here for the specific submission status.",
    "大幅減少（-20%以上）":"There have been fewer posts recently. Short posts are OK! Feel free to share them!",
    "微減・現状維持（±10%）": "Thank you for your consistent posts. Let's gamba together today to further activate the site!",
    "増加（+10%以上）": "The number of posts is increasing! Thank you for everyone's active sharing! Let's keep going at this pace and aim to reach 90%!",
    "反応なし": "Let's react to everyone's posts! Start with a simple 'Like!'",
    "いいねのみ": "Thank you for the likes! Why not expand your communication with stamps and comments?",
    "多様な反応": "Thank you for the well-balanced reactions! The team ties are getting stronger!",
    "reaction_compare": "Number of reactions to posts compared to last month",
    "反応減少（-20%以上）": "It seems that team interaction has decreased a little. Why not add a short message to your colleagues' posts?",
    "反応現状維持（±10%）": "Stable interaction continues. Share your new discoveries and realizations in the comments!",
    "反応増加（+10%以上）": "Everyone's active interactions are increasing! The atmosphere in this team is great!✨",
    "投稿率算出": "By setting a submission date, you can get a more accurate grasp of the submission status of daily reports.",
    "gamba!にご相談": "If you have any problems with operation, please contact gamba! at any time!",
    "gamba!活用サポート予約窓口": "gamba! Support Reservation.",
    "ご予約はこちら": "Reservations can be made here",
    "提出状況": "Submission status",
    "提出状況エクスポート": "Export Submission status",
    "週の投稿": "{{week_number}} week posts",
    "こちらの使い方ガイド": "this guide",
    "report_collection": "Collection period: {{start_date, date}}~{{end_date, date}}",
    "report_subject": "【{{month}} {{group_name}} Group Posts and reactions Report】",
    "reaction_subject": "・Reactions to posts: {{likes}} likes, {{comments}} comments and stamps",
    "パターン1": "There were {{posts}} posts. How active is your team? To create an atmosphere where members can post freely, send comments and 'likes' from the administrator!",
    "パターン2": "{{posts}} posts were shared. Have you noticed any changes in the content or quality of posts? If you notice something different from usual, try responding with a comment!",
    "パターン3": "There were {{posts}} posts. Take a look at posts from members who don't usually post much. You may notice their unique perspective!",
    "パターン4": "There were {{posts}} activity shares. Were there any posts that received a particularly strong response within the team? Try sharing the key points of such posts with other members!",
    "パターン5": "{{posts}} posts were collected. Why not find a topic where members are actively sharing information among themselves and use that as a basis for reaching out to them?",
    "パターン6": "{{posts}} posts were shared. Have you noticed anything particularly useful? Try to give specific feedback on such posts in the comments!",
    "パターン7": "There were {{posts}} posts. What were the most popular topics within the team? Commenting on popular topics may lead to further sharing of ideas!",
    "パターン8": "There were {{posts}} posts. Was there active exchange of comments between members? If there are interesting discussions, try adding comments from the administrator's perspective!",
    "パターン9": "There were {{posts}} posts. Reactions to posts made first thing in the morning or at the beginning of the week will help your team get off to a good start each day and week. Try to reach out to them proactively!",
    "パターン10": "{{posts}} activity reports were collected. Why not try to provide particularly detailed feedback on reports of new initiatives and improvements?",
    "パターン11": "There were {{posts}} posts. When sharing problems or issues, try to support them with advice that makes use of your team's experience and knowledge!",
    "パターン12": "{{posts}} posts were shared. Pay particular attention to topics about collaboration and cooperation with other departments. It may be an opportunity to expand horizontal connections!",
    "パターン13": "There were {{posts}} posts. Were there any posts that made you feel that your team members had grown or realized something? If you notice such a change, acknowledge it with specific words!",
    "パターン14": "There were {{posts}} posts. If you find any ideas or techniques shared within the team, be sure to comment, 'That's helpful!'",
    "パターン15": "{{posts}} posts were shared. Why not find some good changes or growth in your team among the posts and share them with everyone?",
    "パターン16": "{{posts}} activity shares were confirmed. Are there any trends in the time of posting? Try to understand the rhythm of your team's activities and make an effort to speak to them in a timely manner!",
    "パターン17": "There were {{posts}} posts. Did you get a sense of the team's atmosphere? For more active communication, start by expressing your honest thoughts as an administrator!",
    "パターン18": "{{posts}} posts have been shared. Pay attention to reports of small individual ideas and improvements. They may become an asset for the whole team!",
    "レスポンスいいねのみ": "Express your feelings using comments and stamps!",
    "レスポンス量増加": "gamba! seems to be more exciting than the whole period!",
    "レスポンス量減少": "Responses are on the decline. Let's all get excited!",
    "Section preferences have been updated": "Section preferences have been updated.",
    "Section": "Section",
    "Section(unread)": "Section(unread)",
    "Section name": "Section name",
    "Division visibility": "Division visibility",
    "Group management": "Group management",
    "Download": "Download",
    "Move to trash": "Move to trash",
    "persons_count": "{{ value }} member(s)",
    "Section settings": "Section settings",
    "are_you_sure_you_want_to_move_the_division_to_trash": "This Section will be moved to trash. \nAre you sure you want to move the Section to trash?",
    "this_operation_will_affect_all_users_participating_in_the_division": "This operation affects all groups participating in the Section.",
    "complete_deletion_restoration_explanation": "To delete completely or restore a Section, you need to do the operations of \"Permanently delete\" or \"Return from trash\" on the account management screen.",
    "export_all_groups": "Extract all Group",
    "既存グループを追加": "Add existing group",
    "Select_group": "Select group",
    "division_group_remove_consequence": "You can still view past posts even if you leave the section.",
    "can_i_remove_group": "Are you sure you want to remove {{ name }} as a group?",
    "Return to linked section": "Return to linked section",
    "Move to first level": "Move to first level",
    "選択できるグループがありません": "There are no groups to select.",
    "セクションなし": "No section",
    "AIレビュー":"AI review",
    "この情報は役に立ちましたか":"Was this information helpful?",
    "レポートお礼":"Thank you for your cooperation!",
    "レビューする":"Review",
    "レビュー注意":"While this app's AI technology strives for excellence, its responses may contain inaccuracies or misunderstandings.",
    "注意URL":"https://www.getgamba.com/info/archives/52230/",
    "利用規約":"read more",
    "拡張機能":"extensions",
    "レビュー機能":"AI Review feature (Beta)",
    "レビュー機能ON":"AI Review feature (Beta) is currently enabled. To disable it, please contact your account administrator.(You can change this from Account Management Screen > Advanced Settings > Extensions Settings.)",
    "レビュー機能OFF":"AI Review feature (Beta) is currently disabled. To enable it, please contact your account administrator.(You can change this from Account Management Screen > Advanced Settings > Extensions Settings.)",
  },
  error: {
    "メールアドレスを入力してください": "Please enter your e-mail address.", // メールアドレスを入力してください。
    "パスワードを入力してください": "Please enter your password.", // パスワードを入力してください。
    "確認コードを入力してください": "Please enter pass code.", // 確認コードを入力してください
    "タイトルを入力してください": "Please enter a title.", // タイトルを入力してください。
    "テンプレート名を入力してください": "Please enter a template name.", // テンプレート名を入力してください。
    "本文を入力してください": "Please enter the text", // 本文を入力してください
    "ユーザ名を入力してください": "Please enter your username.", // ユーザ名を入力してください。
    "グループ名を入力してください": "Please enter a group name.", // グループ名を入力してください。
    "KPI名を入力してください": "Please enter a KPI name.", // KPI名を入力してください。
    "単位を入力してください": "Please enter a unit.", // 単位を入力してください。
    "目標値を入力してください": "Please enter a target value.", // 目標値を入力してください。
    "実績値を入力してください": "Please enter the actual value.", // 実績値を入力してください。
    "フィールド種別を選択してください": "Select an input type.", // 入力種別を選択してください。
    "フィールド名を入力してください": "Please enter an item name.", // 項目名を入力してください。
    "フィールドの選択肢を入力してください": "Specify one or more choices for the input item.", // 入力項目の選択肢を1つ以上指定してください。
    "入力されていません": "Not entered.", // 入力されていません。
    "チャットルーム名を入力してください": "Please enter a chat room name", // チャットルーム名を入力してください
    fetch_error: "Unable to connect to server. A network error has occurred.", // サーバに接続できません。ネットワークエラーが発生しました。
    s3upload: "Upload of video file failed. Please try again later.", // 動画ファイルのアップロードに失敗しました。時間をおいて再度お試しください。
    invalid_flie: "Upload some file failed. Not support file included.",       // 選択された一部のファイルはサポートされておりません
    "サーバ切断": "The server connection has been disconnected. Reconnecting.", // サーバの接続が切断されました。再接続中です。
    "サーバ接続": "Server connection has been restored.", // サーバの接続が復旧しました。
    "google-calendar-events": "Can't get the calendar for Google Calendar.", // Googleカレンダーの予定表が取得できません。
    "google-calendar-list": "Can't get the calendar for Google Calendar.", // Googleカレンダーの予定表が取得できません。
    "google-drive-folders": "Can't get the folders for GoogleDrive.", // Googleドライブのフォルダリストを取得できません。
    "google-drive-userinfo": "Can't get the user info for GoogleDrive.", // Googleドライブのユーザー情報を取得できません。
    "google-refresh-token": "Can't get the refresh token.", // refresh tokenが取得できません。
    "fetch-scheduled-settings": "Can't get the scheduled execution settings.", // 定期実行設定を取り込めません。
    "update-scheduled-settings": "Can't update the scheduled execution settings.", // 定期実行設定が更新できません。
    "upload-google-drive-file": "Can't upload the file to GoogleDrive.", // Googleドライブにファイルをアップロードできません。
    "画像の読み込みに失敗しました": "The file does not exist or cannot be displayed.", // 存在しないか表示できないファイルです。
    "暗号化PDF説明": "* For encrypted files, you may be able to open it　　from the \"Display in another window\" icon on the upper right.",   // * 暗号化されたファイルの場合、右上の　「別ウィンドウで表示」のアイコンから開ける可能性があります。
    "読み込みに失敗しました": "Reading data failed.", // データの読み込みに失敗しました。
    "ファイルが選択されていません": "Either no file has been selected or access to the photo or camera has not been granted.", // ファイルが選択されていないか、写真もしくはカメラへのアクセスが許可されていません。
    "フォトライブラリに保存できませんでした": "The attached image could not be saved.", // 添付画像の保存ができませんでした。
    "データの送信に失敗しました": "Post submission failed. Please check your internet connection and try again.", // 投稿の送信に失敗しました。インターネット接続を確認し、再度お試しください。
    "インターネット接続に問題があります": "The temporary connection cannot be saved because the Internet connection cannot be confirmed.", // インターネット接続が確認できないため、投稿の一時保存ができません。
    "インターネット再接続": "Reconnecting to the internet. Temporary saving of posts have not completed yet.", // インターネット再接続しています。投稿の一時保存まだ完了しておりません。
    "インターネット接続を確認してください": "Please try again while connected to the Internet.", // インターネットに接続された状態で再度お試しください。
    "別の投稿を編集中です": "Cannot open the post because another post is being edited.", // 現在別の投稿を編集中のため開くことができません。
    "unavailable": "gamba! Is currently unavailable. Please wait.", // 現在、gamba!はご利用いただけません。しばらくお待ちください。
    "URLが開けません": "Cannot open the URL", //  URLが開けません
    "コピーして下さい": "Please copy the link from the button below and access it from your browser. \n\n", // 下記ボタンより、リンクをコピーしてブラウザからアクセスして下さい。
    "ファイルサイズが制限を超えています": "The file size has exceeded the limit. You cannot upload a file larger than {{ max_file_size }}.",
    "MSアカウント": "Your Microsoft account does not support calendars."
  },
  url: {
    "gambaにログインできない": "https://support.getgamba.com/hc/ja/articles/900001776883",
    "無料体験リンク": "https://www.getgamba.com/v3/registration/new",
    "attachmentInfo": "https://support.getgamba.com/hc/ja/articles/900005545463",
  },
  timezone: {
    "UTC-12": "Baker Island, Howland Island", // ベーカー島 ハウランド島
    "UTC-11": "American Samoa Niue", // アメリカ領サモア ニウエ
    "UTC-10": "Hawaii Aleutian Islands", // ハワイ アリューシャン列島西部
    "UTC-9": "Alaska", // アラスカ
    "UTC-8": "United States, Canada, Mexico (Pacific Time)", // アメリカ・カナダ・メキシコ（太平洋時間）
    "UTC-7": "United States, Canada, Mexico (mountain time)", // アメリカ・カナダ・メキシコ（山岳部時間）
    "UTC-6": "United States, Canada, Mexico (Central Time), Central America", // アメリカ・カナダ・メキシコ（中部時間） 中央アメリカ
    "UTC-5": "United States and Canada (Eastern Time), Cuba Peru", // アメリカ・カナダ（東部時間） キューバ ペルー
    "UTC-4": "Canada (Atlantic Time), Majority of the Lesser Antilles, Venezuela, Brazil (Amazon Time), Chile", // カナダ（大西洋時間） 小アンティル諸島の大部分 ベネズエラ ブラジル（アマゾン時間） チリ
    "UTC-3": "Brazil (Brazil time), Argentina, Greenland", // ブラジル（ブラジル時間） アルゼンチン グリーンランド
    "UTC-2": "Brazil (Fernando de Noronha)", // ブラジル（フェルナンド・デ・ノローニャ島）
    "UTC-1": "Azores, Cape Verde", // アゾレス諸島 カーボベルデ
    "UTC+0": "United Kingdom, Ireland, Portugal, Iceland, Africa Rocco, Ghana etc.", // イギリス アイルランド ポルトガル アイスランド アフリゃ�ロッコ ガーナ等
    "UTC+1": "Central European Time (France, Germany, etc.), West Africa Time (Nigeria, Congo, etc.)", // 中央ヨーロッパ時間（フランス ドイツ等） 西アフリカ時間（ナイジェリア コンゴ等）
    "UTC+2": "Eastern European Time (Finland Ukraine Greece etc.), Central African Time, South Africa", // 東ヨーロッパ時間（フィンランド ウクライナ ギリシャ等） 中央アフリカ時間 南アフリカ
    "UTC+3": "Russia (Moscow), Belarus, Saudi Arabia, East Africa Time", // ロシア（モスクワ） ベラルーシ サウジアラビア 東アフリカ時間
    "UTC+4": "Russia (Samara), Azerbaijan, Georgia, United Arab Emirates, Mauritius", // ロシア（サマラ） アゼルバイジャン グルジア アラブ首長国連邦 モーリシャス
    "UTC+5": "Russia (Yekaterinburg), Pakistan", // ロシア（エカテリンブルグ） パキスタン
    "UTC+6": "Russia (Omsk), Kazakhstan, Bangladesh", // ロシア（オムスク） カザフスタン バングラディシュ
    "UTC+7": "Russia (Krasnoyarsk), Thailand, Vietnam, Western Indonesia Time", // ロシア（クラスノヤルスク） タイ ベトナム インドネシア西部時間
    "UTC+8": "Russia (Irkutsk), China, Mongolia, Malaysia, Western Australia Time", // ロシア（イルクーツク） 中国 モンゴル マレーシア オーストラリア西部時間
    "UTC+9": "Japan, Russia (Yakutsk), South Korea, Palau", // 日本 ロシア（ヤクーツク） 韓国 パラオ
    "UTC+10": "Russia (Vladivostok), Guam, Eastern Australia Time", // ロシア（ウラジオストク） グアム オーストラリア東部時間
    "UTC+11": "Russia (Magadan), Solomon Islands, New Caledonia", // ロシア（マガダン） ソロモン諸島 ニューカレドニア
    "UTC+12": "Russia (Kamchatka), New Zealand, Fiji, Kiribati (Gilbert Islands)", // ロシア（カムチャッカ） ニュージーランド フィジー キリバス（ギルバート諸島）
    "UTC+13": "Tonga Kiribati (Phoenix Islands), Samoa, Tokelau", // トンガ キリバス（フェニックス諸島） サモア トケラウ
    "UTC+14": "Kiribati (Line Islands)", // キリバス（ライン諸島）
  },
  language: {
    "ja": "Japanese",
    "en": "English",
  },
};



// WEBPACK FOOTER //
// ./src/i18n/message-en.js